export const rndColor=()=>{
  const colors=[
      "#AA9C75",
    "rgb(69,101,113)",
    "rgb(83,84,216)",
    "rgb(42,134,211)",
    "rgb(45,71,189)",
    "rgb(170,200,226)",
    "rgb(59,121,25)",
  ]
  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}


export const recentActs = [
  {
    alphabet: "S",
    time: "Now",
    schoolName: "St. Crigs High School",
    schoolDetail: "St Crigs High School completed their registration",
    bg: "#AA9C75",

    id: 1,
  },
  {
    alphabet: "D",
    time: "10 mins ago",
    schoolName: "Dominic College",
    schoolDetail: "St Dominic College renewed their subscription.",
    bg: "rgb(69,101,113)",

    id: 2,
  },
  {
    alphabet: "C",
    time: "20 mins ago",
    schoolName: "CharlesLake School",
    schoolDetail: "CharlesLake School subscription just expired.",
    bg: "rgb(83,84,216)",

    id: 3,
  },
  {
    alphabet: "D",
    time: "40 mins ago",
    schoolName: "Dowen College",
    schoolDetail: "Down College paid their subscription fee.",
    bg: "rgb(42,134,211)",

    id: 4,
  },
  {
    alphabet: "D",
    time: "40 mins ago",
    schoolName: "Dowen College",
    schoolDetail: "Dowen College completed their registration",
    bg: "rgb(42,134,211)",

    id: 5,
  },
  {
    alphabet: "B",
    time: "1hr ago",
    schoolName: "British College Enugu",
    schoolDetail:
      "British College Enugu completed their registration and has been add to South East Zone.",
    bg: "rgb(42,134,211)",

    id: 6,
  },
  {
    alphabet: "W",
    time: "1hr ago",
    schoolName: "WiseVille Montessori",
    schoolDetail: "WiseVille Montessori subscription has expired.",
    bg: "rgb(45,71,189)",

    id: 7,
  },
  {
    alphabet: "W",
    time: "1hr ago",
    schoolName: "Imad Schools",
    schoolDetail: "Imad Schools subscription just expired",
    bg: "rgb(170,200,226)",

    id: 8,
  },
  {
    alphabet: "S",
    time: "3 hrs ago",
    schoolName: "Sultan High School ….",
    schoolDetail: "British College Enugu subscription has expired",
    bg: "rgb(59,121,25)",

    id: 9,
  },
];
